import { Change, ChangeType, Element, UserVersion } from "../index";
import { normalizeElementThickness } from "../elementThickness";
import { isNewerVersion } from "./isNewerVersion";

export type ElementMap = Record<string, Element>;
export type ElementVersions = Record<string, UserVersion>;

export interface FoldChangesOptions {
  useTombstone?: boolean;
}

export const applyChangesToElements = (
  elements: ElementMap,
  elementVersions: ElementVersions,
  changes: Change[],
  options: FoldChangesOptions = {}
): void => {
  const { useTombstone = false } = options;

  changes.forEach((change) => {
    const { object: newElement } = change;
    const prevElement = elements[newElement.id];
    const isDeletion = change.changeType === ChangeType.Delete;
    const prevVersion = useTombstone
      ? (prevElement?.userVersion ?? elementVersions[newElement.id])
      : prevElement?.userVersion;
    const shouldUpdate = isNewerVersion(newElement.userVersion, prevVersion);

    if (shouldUpdate) {
      elementVersions[newElement.id] = newElement.userVersion;
      elements[newElement.id] = normalizeElementThickness(newElement);
    }
    // Deletions always take precedent over any other changes.
    if (shouldUpdate && isDeletion) {
      delete elements[newElement.id];
    }
  });
};

export const foldChanges = (
  changes: Change[],
  options: FoldChangesOptions = {}
): ElementMap => {
  const elements: ElementMap = {};
  applyChangesToElements(elements, {}, changes, options);
  return elements;
};
